import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';

export interface AboutVersions {
  deviceGateway: string;
  analyticsPlatform: string;
}

interface ServiceVersion {
  serviceName: string;
  releaseVersion: string | null;
  buildVersion: string | null;
}

interface ServicesResponse {
  serviceVersions?: ServiceVersion[];
}

const DEVICE_GATEWAY_SERVICE = 'device gateway';
const ANALYTICS_PLATFORM_SERVICE = 'analytics platform';

const formatVersion = (service?: ServiceVersion): string => {
  const { releaseVersion, buildVersion } = service ?? {};
  if (!releaseVersion) {
    return buildVersion ?? '';
  }
  return buildVersion ? `${releaseVersion} (${buildVersion})` : releaseVersion;
};

@Injectable({ providedIn: 'root' })
export class AboutService {
  private readonly http = inject(HttpClient);

  getVersions(): Observable<AboutVersions> {
    return this.http.get<ServicesResponse>('api/about/services').pipe(
      map(({ serviceVersions = [] }) => {
        const find = (name: string): ServiceVersion | undefined =>
          serviceVersions.find(s => s.serviceName.toLowerCase().startsWith(name));
        return {
          deviceGateway: formatVersion(find(DEVICE_GATEWAY_SERVICE)),
          analyticsPlatform: formatVersion(find(ANALYTICS_PLATFORM_SERVICE))
        };
      }),
      catchError(() => of({ deviceGateway: '', analyticsPlatform: '' }))
    );
  }
}
